<template>
    <div id="app">
        <div class="menu-tab fade-in">
            <img class="icon-menu-list" src="assets/img/trebol-inactivo.png" alt="" />
            <img class="icon-menu-active" src="assets/img/flechas-izquierda.png" alt="" />
        </div>

        <MenuHide></MenuHide>

        <SocialNav></SocialNav>

        <CoverPage></CoverPage>

        <section class="container" id="aboutus">
            <article class="about-us">
                <div class="title">
                    <!-- <div class="title-line">
                        <span></span>
                    </div> -->
                </div>
                <div class="content">
                    <div>
                        <h2><span>About us</span></h2>
                        <p>
                            Fortune Society is a philosophy that states a change in the financial, social and economic culture and structure in the world through cryptos and NFTs.
                        </p>
                        <p>
                            We've come together as a professional and organized NFT agency to help our partners, from all around the world, to develop their own projects in the market according to their field of choice.
                        </p>
                        <p>
                            Our team of experts grant you a solid and structured project to take your business further into wealth and fortune.
                        </p>
                    </div>
                </div>
            </article>
        </section>

        <section class="container" id="team">
            <article class="our-team">
                <div class="title">
                    <!-- <div class="title-line">
                        <span></span>
                    </div> -->
                    <h2><span>MEET THE FORTUNE TEAM</span></h2>
                </div>
                <div class="content">
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Quiqe.jpg" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Quiqe-photo.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Enrique Terrazas</h4>
                            <p>CEO</p>
                            <span>
                                <a
                                    href="https://www.instagram.com/enriqueterrazas99"
                                    target="_blank"
                                    class="instagram-account"
                                >
                                    <i class="fab fa-instagram"></i> @enriqueterrazas99
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Gilio.jpg" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Gilio.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Gustavo Gilio</h4>
                            <p>COO</p>
                            <span>
                                <a
                                    href="https://www.instagram.com/gustavogilio"
                                    target="_blank"
                                    class="instagram-account"
                                >
                                    <i class="fab fa-instagram"></i> @gustavogilio
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Diego.jpg" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Diego.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Diego Izaguirre</h4>
                            <p>CCO</p>
                            <span>
                                <a href="https://www.instagram.com/diegoizag" target="_blank" class="instagram-account">
                                    <i class="fab fa-instagram"></i> @diegoizag
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Jorge.jpg" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Jorge-photo.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Jorge Gidi</h4>
                            <p>CTO</p>
                            <span>
                                <a
                                    href="https://www.instagram.com/jorge.technology"
                                    target="_blank"
                                    class="instagram-account"
                                >
                                    <i class="fab fa-instagram"></i> @jorge.technology
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Carlos.jpg" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Carlos-photo.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Carlos Ortiz</h4>
                            <p>CLA</p>
                            <span>
                                <a
                                    href=""
                                    target="_blank"
                                    class="instagram-account"
                                >
                                    <i class="fab fa-instagram"></i> 
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Ferran.jpg" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Ferran-photo.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Ferran Zozaya</h4>
                            <p>Artist</p>
                            <span>
                                <a
                                    href="https://www.instagram.com/ferranzozaya2.0"
                                    target="_blank"
                                    class="instagram-account"
                                >
                                    <i class="fab fa-instagram"></i> @ferranzozaya2.0
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Andres.JPG" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Andres-photo.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Andrés González</h4>
                            <p>CFO</p>
                            <span>
                                <a
                                    href="https://www.instagram.com/andresgzzsegovia"
                                    target="_blank"
                                    class="instagram-account"
                                >
                                    <i class="fab fa-instagram"></i> @andresgzzsegovia
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Gerardo.jpg" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Gerardo.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Gerardo Alonso</h4>
                            <p>Strategic PR</p>
                            <span>
                                <a
                                    href="https://www.instagram.com/alcgerardo"
                                    target="_blank"
                                    class="instagram-account"
                                >
                                    <i class="fab fa-instagram"></i> @alcgerardo
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="card-profile">
                        <div class="flip-box">
                            <div class="flip-box-inner">
                                <div class="flip-box-front">
                                    <figure>
                                        <img class="photo-avatar" src="assets/img/team/Gonzalo.jpg" alt="" />
                                    </figure>
                                </div>
                                <div class="flip-box-back">
                                    <figure>
                                        <img class="elf-avatar" src="assets/img/team/Gonzalo-photo.jpg" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="card-info">
                            <h4>Gonzalo Bañuelos</h4>
                            <p>CIO</p>
                            <span>
                                <a
                                    href="https://www.instagram.com/gonzalobam.eth"
                                    target="_blank"
                                    class="instagram-account"
                                >
                                    <i class="fab fa-instagram"></i> @gonzalobam.eth
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <section class="container" id="nfts-genesis">
            <article class="principals-nfts">
                <div class="title">
                    <!-- <div class="title-line">
                        <span></span>
                    </div> -->
                    <h2><span>GENESIS</span></h2>
                </div>
                <p style="text-align: center; margin-top: 15px;">
                    Fortune Genesis is our first and most exclusive NFT collection of 50 unique, 3D art pieces, handmade in 8k quality by the artist, owned by handpicked members that add value to the society through their experience and fields of expertise; Finance, politics, sports, arts, etc. By means of conferences, courses, talks, and private events to help society thrive.
                </p>
                <div class="content">
                    <div class="swiper-slide">
                        <!-- <div class="swiper-slide-autor">
                            <figure class="swiper-slide-autor-image">
                                <img
                                    src="https://images.unsplash.com/photo-1618641986557-1ecd230959aa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                                    alt="FORTUNELF - Jhon Due"
                                />
                                <span>Jhon Due</span>
                            </figure>
                        </div> -->
                        <div class="swiper-slide-image">
                            <figure>
                                <img
                                    src="assets/img/Genesis.jpeg"
                                    alt="FORTUNELF - Elfo uno"
                                />
                            </figure>
                        </div>
                        <div class="swiper-slide-info">
                            <div class="swiper-slide-info-text">
                                <h4>Genesis</h4>
                                <p>Price: <span>0.29 ETH</span></p>
                            </div>
                            <div class="swiper-slide-info-reaction">
                                <i class="fa-solid fa-images"></i>
                                <!-- <i class="far fa-heart"></i> -->
                                <span>x/50</span>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <!-- <div class="swiper-slide-autor">
                            <figure class="swiper-slide-autor-image">
                                <img
                                    src="https://images.unsplash.com/photo-1536164261511-3a17e671d380?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=682&q=80"
                                    alt="FORTUNELF - Tommy Rivera"
                                />
                                <span>Tommy Rivera</span>
                            </figure>
                        </div> -->
                        <div class="swiper-slide-image">
                            <figure>
                                <img
                                    src="assets/img/Archangel.jpeg"
                                    alt="FORTUNELF - Elfo dos"
                                />
                            </figure>
                        </div>
                        <div class="swiper-slide-info">
                            <div class="swiper-slide-info-text">
                                <h4>Archangel</h4>
                                <p>Price: <span>0.29 ETH</span></p>
                            </div>
                            <div class="swiper-slide-info-reaction">
                                <i class="fa-solid fa-images"></i>
                                <!-- <i class="far fa-heart"></i> -->
                                <span>x/50</span>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <!-- <div class="swiper-slide-autor">
                            <figure class="swiper-slide-autor-image">
                                <img
                                    src="https://images.unsplash.com/photo-1587723958656-ee042cc565a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                                    alt="FORTUNELF - Gerald Bishop"
                                />
                                <span>Gerald Bishop</span>
                            </figure>
                        </div> -->
                        <div class="swiper-slide-image">
                            <figure>
                                <img
                                    src="assets/img/Nero.jpeg"
                                    alt="FORTUNELF - Elfo tres"
                                />
                            </figure>
                        </div>
                        <div class="swiper-slide-info">
                            <div class="swiper-slide-info-text">
                                <h4>Nero</h4>
                                <p>Price: <span>0.29 ETH</span></p>
                            </div>
                            <div class="swiper-slide-info-reaction">
                                <i class="fa-solid fa-images"></i>
                                <!-- <i class="far fa-heart"></i> -->
                                <span>x/50</span>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <!-- <div class="swiper-slide-autor">
                            <figure class="swiper-slide-autor-image">
                                <img
                                    src="https://images.unsplash.com/photo-1608155686393-8fdd966d784d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                                    alt="FORTUNELF - Louis Nelson"
                                />
                                <span>Louis Nelson</span>
                            </figure>
                        </div> -->
                        <div class="swiper-slide-image">
                            <figure>
                                <img
                                    src="assets/img/Foresto.jpeg"
                                    alt="FORTUNELF - Elfo uno"
                                />
                            </figure>
                        </div>
                        <div class="swiper-slide-info">
                            <div class="swiper-slide-info-text">
                                <h4>Foresto</h4>
                                <p>Price: <span>0.29 ETH</span></p>
                            </div>
                            <div class="swiper-slide-info-reaction">
                                <i class="fa-solid fa-images"></i>
                                <!-- <i class="far fa-heart"></i> -->
                                <span>x/50</span>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <!-- <div class="swiper-slide-autor">
                            <figure class="swiper-slide-autor-image">
                                <img
                                    src="https://images.unsplash.com/photo-1609010697446-11f2155278f0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                                    alt="FORTUNELF - Billie Rice"
                                />
                                <span>Billie Rice</span>
                            </figure>
                        </div> -->
                        <div class="swiper-slide-image">
                            <figure>
                                <img
                                    src="assets/img/CaptainEli.jpeg"
                                    alt="FORTUNELF - Elfo cuatro"
                                />
                            </figure>
                        </div>
                        <div class="swiper-slide-info">
                            <div class="swiper-slide-info-text">
                                <h4>Captain Eli</h4>
                                <p>Price: <span>0.29 ETH</span></p>
                            </div>
                            <div class="swiper-slide-info-reaction">
                                <i class="fa-solid fa-images"></i>
                                <!-- <i class="far fa-heart"></i> -->
                                <span>x/50</span>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <!-- <div class="swiper-slide-autor">
                            <figure class="swiper-slide-autor-image">
                                <img
                                    src="https://images.unsplash.com/photo-1609010697446-11f2155278f0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                                    alt="FORTUNELF - Billie Rice"
                                />
                                <span>Billie Rice</span>
                            </figure>
                        </div> -->
                        <div class="swiper-slide-image">
                            <figure>
                                <img
                                    src="assets/img/Flingo.jpeg"
                                    alt="FORTUNELF - Elfo cuatro"
                                />
                            </figure>
                        </div>
                        <div class="swiper-slide-info">
                            <div class="swiper-slide-info-text">
                                <h4>Flingo</h4>
                                <p>Price: <span>0.29 ETH</span></p>
                            </div>
                            <div class="swiper-slide-info-reaction">
                                <i class="fa-solid fa-images"></i>
                                <!-- <i class="far fa-heart"></i> -->
                                <span>x/50</span>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <!-- <div class="swiper-slide-autor">
                            <figure class="swiper-slide-autor-image">
                                <img
                                    src="https://images.unsplash.com/photo-1609010697446-11f2155278f0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                                    alt="FORTUNELF - Billie Rice"
                                />
                                <span>Billie Rice</span>
                            </figure>
                        </div> -->
                        <div class="swiper-slide-image">
                            <figure>
                                <img
                                    src="assets/img/MagumaKami.jpeg"
                                    alt="FORTUNELF - Elfo cuatro"
                                />
                            </figure>
                        </div>
                        <div class="swiper-slide-info">
                            <div class="swiper-slide-info-text">
                                <h4>Maguma Kami</h4>
                                <p>Price: <span>0.29 ETH</span></p>
                            </div>
                            <div class="swiper-slide-info-reaction">
                                <i class="fa-solid fa-images"></i>
                                <!-- <i class="far fa-heart"></i> -->
                                <span>x/50</span>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <!-- <div class="swiper-slide-autor">
                            <figure class="swiper-slide-autor-image">
                                <img
                                    src="https://images.unsplash.com/photo-1609010697446-11f2155278f0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                                    alt="FORTUNELF - Billie Rice"
                                />
                                <span>Billie Rice</span>
                            </figure>
                        </div> -->
                        <div class="swiper-slide-image">
                            <figure>
                                <img
                                    src="assets/img/UnbotheredElton.jpeg"
                                    alt="FORTUNELF - Elfo cuatro"
                                />
                            </figure>
                        </div>
                        <div class="swiper-slide-info">
                            <div class="swiper-slide-info-text">
                                <h4>Unbothered Elton</h4>
                                <p>Price: <span>0.29 ETH</span></p>
                            </div>
                            <div class="swiper-slide-info-reaction">
                                <i class="fa-solid fa-images"></i>
                                <!-- <i class="far fa-heart"></i> -->
                                <span>x/50</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="button">
                        <a href="nfts.html"><span>Explore all NFTs</span></a>
                    </div> -->
                </div>
            </article>
        </section>

        <section class="container" id="nfts-elves">
            <div class="nft-elfs-container">
                <div class="nft-elfs-text">
                    <h2><span>The Elves</span></h2>
                    <p>
                        Fortune Elf Society is a collection of 5000, 3D unique elves carefully designed with 8K quality, united on the Ethereum blockchain.
                    </p>
                    <p>
                        Each elf is made with a combination of hundreds of particular elements that make them stand out and attract NFT enthusiasts.
                    </p>
                    <p>
                        By joining the society, you become part of the most exclusive and world changing, inspiring group of people.
                    </p>
                </div>
                <div class="swiper-container">
                    <div class="swiper mySwiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <!-- <div class="swiper-slide-autor">
                                    <figure class="swiper-slide-autor-image">
                                        <img
                                            src="https://images.unsplash.com/photo-1618641986557-1ecd230959aa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                                            alt="FORTUNELF - Jhon Due"
                                        />
                                        <span>Jhon Due</span>
                                    </figure>
                                    <a href="/" class="swiper-slide-autor-options">
                                        <i class="fas fa-ellipsis-h"></i>
                                    </a>
                                </div> -->
                                <div class="swiper-slide-image">
                                    <figure>
                                        <img
                                            src="assets/img/Genesis.jpeg"
                                            alt="FORTUNELF - Elfo uno"
                                        />
                                    </figure>
                                </div>
                                <div class="swiper-slide-info">
                                    <div class="swiper-slide-info-text">
                                        <h4>Genesis</h4>
                                        <p>Price: <span>0.29 ETH</span></p>
                                    </div>
                                    <div class="swiper-slide-info-reaction">
                                        <i class="fa-solid fa-images"></i>
                                        <span>x/50</span>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <!-- <div class="swiper-slide-autor">
                                    <figure class="swiper-slide-autor-image">
                                        <img
                                            src="https://images.unsplash.com/photo-1536164261511-3a17e671d380?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=682&q=80"
                                            alt="FORTUNELF - Tommy Rivera"
                                        />
                                        <span>Tommy Rivera</span>
                                    </figure>
                                    <a href="/" class="swiper-slide-autor-options">
                                        <i class="fas fa-ellipsis-h"></i>
                                    </a>
                                </div> -->
                                <div class="swiper-slide-image">
                                    <figure>
                                        <img
                                            src="assets/img/Archangel.jpeg"
                                            alt="FORTUNELF - Elfo dos"
                                        />
                                    </figure>
                                </div>
                                <div class="swiper-slide-info">
                                    <div class="swiper-slide-info-text">
                                        <h4>Archangel</h4>
                                        <p>Price: <span>0.29 ETH</span></p>
                                    </div>
                                    <div class="swiper-slide-info-reaction">
                                        <i class="fa-solid fa-images"></i>
                                        <span>x/50</span>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <!-- <div class="swiper-slide-autor">
                                    <figure class="swiper-slide-autor-image">
                                        <img
                                            src="https://images.unsplash.com/photo-1587723958656-ee042cc565a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                                            alt="FORTUNELF - Gerald Bishop"
                                        />
                                        <span>Gerald Bishop</span>
                                    </figure>
                                    <a href="/" class="swiper-slide-autor-options">
                                        <i class="fas fa-ellipsis-h"></i>
                                    </a>
                                </div> -->
                                <div class="swiper-slide-image">
                                    <figure>
                                        <img
                                            src="assets/img/Nero.jpeg"
                                            alt="FORTUNELF - Elfo tres"
                                        />
                                    </figure>
                                </div>
                                <div class="swiper-slide-info">
                                    <div class="swiper-slide-info-text">
                                        <h4>Nero</h4>
                                        <p>Price: <span>0.29 ETH</span></p>
                                    </div>
                                    <div class="swiper-slide-info-reaction">
                                        <i class="fa-solid fa-images"></i>
                                        <span>x/50</span>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <!-- <div class="swiper-slide-autor">
                                    <figure class="swiper-slide-autor-image">
                                        <img
                                            src="https://images.unsplash.com/photo-1608155686393-8fdd966d784d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                                            alt="FORTUNELF - Louis Nelson"
                                        />
                                        <span>Louis Nelson</span>
                                    </figure>
                                    <a href="/" class="swiper-slide-autor-options">
                                        <i class="fas fa-ellipsis-h"></i>
                                    </a>
                                </div> -->
                                <div class="swiper-slide-image">
                                    <figure>
                                        <img
                                            src="assets/img/Foresto.jpeg"
                                            alt="FORTUNELF - Elfo uno"
                                        />
                                    </figure>
                                </div>
                                <div class="swiper-slide-info">
                                    <div class="swiper-slide-info-text">
                                        <h4>Foresto</h4>
                                        <p>Price: <span>0.29 ETH</span></p>
                                    </div>
                                    <div class="swiper-slide-info-reaction">
                                        <i class="fa-solid fa-images"></i>
                                        <span>x/50</span>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <!-- <div class="swiper-slide-autor">
                                    <figure class="swiper-slide-autor-image">
                                        <img
                                            src="https://images.unsplash.com/photo-1609010697446-11f2155278f0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                                            alt="FORTUNELF - Billie Rice"
                                        />
                                        <span>Billie Rice</span>
                                    </figure>
                                    <a href="/" class="swiper-slide-autor-options">
                                        <i class="fas fa-ellipsis-h"></i>
                                    </a>
                                </div> -->
                                <div class="swiper-slide-image">
                                    <figure>
                                        <img
                                            src="assets/img/CaptainEli.jpeg"
                                            alt="FORTUNELF - Elfo cuatro"
                                        />
                                    </figure>
                                </div>
                                <div class="swiper-slide-info">
                                    <div class="swiper-slide-info-text">
                                        <h4>Captain Eli</h4>
                                        <p>Price: <span>0.29 ETH</span></p>
                                    </div>
                                    <div class="swiper-slide-info-reaction">
                                        <i class="fa-solid fa-images"></i>
                                        <span>x/50</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="container" id="roadmap">
            <article class="roadmap">
                <div class="title">
                    <!-- <div class="title-line">
                        <span></span>
                    </div> -->
                    <h2>Roadmap</h2>
                </div>
                <div class="content">
                    <div class="text-box-container">
                        <div class="text-box">
                            <div class="titles">
                                <h4>Ther Elf Launch</h4>
                            </div>
                            <div class="text">
                                A committed team. A strong vision. A shared mission. When the community is ready, 5000 Elves will be released into the Ethereum blockchain. We'll make sure to have the most successful launch in the NFT space and guarantee our holders a rewarding roadmap. The official date will be announced soon.
                            </div>
                        </div>
                        <div class="text-box">
                            <div class="titles">
                                <h4>Live Events</h4>
                            </div>
                            <div class="text">
                                We believe that real life interactions make the best experiences, that's why we will be hosting live events around the country (Mexico) where holders will have exclusive access, to build stronger connections with fellow members to continue expanding and growing our community. Genesis members will be present in each event to establish a working relationship with holders and pursue a stronger bond.
                            </div>
                        </div>
                        <div class="text-box">
                            <div class="titles">
                                <h4>Metaverse</h4>
                            </div>
                            <div class="text">
                                The future is NOW. A space in the metaverse will be bought , so our holders can have a real co-working experience, adapt to the new era, web 3.0, blockchain and more! And, of course, attract FORTUNE.
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="text-box-container">
                        <div class="text-box">
                            <div class="titles">
                                <h4>Boosting our entrepreneurs</h4>
                            </div>
                            <div class="text">
                                Our main goal is to create a strong and united group of entrepreneurs that help each other connect, learn and grow day by day, boosting our society's prosperity. That's why each month the team will invest angel capital in two different startup projects that meet one of the United Nations SDG’s (Sustainable Development Goals) to grow a great, powerful and sustainable business. The chosen projects will have access to mentorship and coaching from the Fortune team and Genesis members.
                            </div>
                        </div>
                        <div class="text-box">
                            <div class="titles">
                                <h4>Learn and Grow</h4>
                            </div>
                            <div class="text">
                                We support the idea that intellect and purpose hold more value than fast cash in the long-term, which is why Genesis members will give live conferences (physically and virtually), lectures, courses, conferences, and events, teaching about their different fields of expertise where holders are able to interact, connect, learn and grow.
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <section class="container" id="faq">
            <article class="faq">
                <div class="title">
                    <!-- <div class="title-line">
                        <span></span>
                    </div> -->
                    <h2>Frequently Asked Questions</h2>
                </div>
                <div class="content">
                    <div class="question-box">
                        <div class="text">
                            <h4 class="question">What is an NFT?</h4>
                            <p class="answer">
                                NFT refers to Non Fungible Token. It is a digital asset that can be bought, sold and traded with cryptocurrencies while sharing real world utilities.
                            </p>
                        </div>
                    </div>
                    <div class="question-box">
                        <div class="text">
                            <h4 class="question">When is the official launch?</h4>
                            <p class="answer">
                                The official launch date for the 5000 Fortune elves is TBA.
                            </p>
                        </div>
                    </div>
                    <div class="question-box">
                        <div class="text">
                            <h4 class="question">How much is a Fortune Elf?</h4>
                            <p class="answer">
                                Mint price TBA.
                            </p>
                        </div>
                    </div>
                    <div class="question-box">
                        <div class="text">
                            <h4 class="question">How can I join the community?</h4>
                            <p class="answer">
                                Join our discord below, fortune awaits!
                            </p>
                        </div>
                    </div>
                    <div class="question-box">
                        <div class="text">
                            <h4 class="question">Who is the Team?</h4>
                            <p class="answer">
                                Fortune Society is a group of persons with alligned passion towards te socioeconomical impact from blockchain technology and how can the implementation of NFT's on a legitimate way can improve the future of innovation in Mexico, Latam and the world.The core team has backgrounds in Technology development, marketing projects involving blockchain and a keen for being the best version of ourselves in life. Conjugating a base of 10 persons together with the key partners "Genesis" as a community to achieve the mission. As a team were remotely located in key locstions that give twrritory and strenght such as. Vancouver, Ca. Austin, Tx, Monterrey, NL and Torreon, Ch.
                            </p>
                        </div>
                    </div>
                    <div class="question-box">
                        <div class="text">
                            <h4 class="question">Which Blockchain are the ELVES deployed on?</h4>
                            <p class="answer">
                                Will be deployed on the Ethereum Blockchain using a ERC-721A Contract.
                            </p>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <footer>
            <div class="video-containter">
                <video playsinline autoplay muted loop poster="polina.jpg" id="bgvid">
                    <source src="assets/img/discord-animation.mp4" type="video/mp4" />
                </video>
            </div>
            <!-- <h2><span>Join</span> the Community</h2>
        <div>
            <span><i class="fab fa-instagram"></i></span>
            <span><i class="fab fa-facebook-square"></i></span>
            <span><i class="fab fa-twitter"></i></span>
            <span><i class="fab fa-twitch"></i></span>
        </div> -->
            <p>FORTUNE SOCIETY | Design and technology by: <a href="https://www.evidencetec.com/evidence-nft">Evidence Technology Blockchain development company</a></p>
        </footer>
    </div>
</template>

<script>
import MenuHide from "./components/MenuHide.vue";
import SocialNav from "./components/SocialNav.vue";
import CoverPage from "./components/CoverPage.vue";

export default {
    name: "App",
    components: { MenuHide, SocialNav, CoverPage },

    data() {
        return {
            settings: false
        };
    }
};
</script>

<style>
@import "./assets/styles/global.css";
</style>
